import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { settingsUrl } from "@presentation/common/settingsRoutes";

const SettingsRouteRedirect: React.FC = () => {
  const { teamId = "", projectId } = useParams<{ teamId: string; projectId: string }>();
  const location = useLocation();
  const scope = projectId ? { level: "project" as const, projectId } : { level: "team" as const, teamId };
  return <Navigate to={`${settingsUrl(scope, new URLSearchParams(location.search))}${location.hash}`} replace />;
};

export default SettingsRouteRedirect;
